const BACKEND_BASE = process.env.REACT_APP_BACKEND_URL;
const INVOICE_DOC_TYPE_NAME = 'Invoice';

const documentTypeIdByTenant = new Map();

export const parseDraftUploadAdditionalDetails = (row) => {
  try {
    if (!row?.additionalDetails) return {};
    const parsed = typeof row.additionalDetails === 'string'
      ? JSON.parse(row.additionalDetails)
      : row.additionalDetails;
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
  } catch {
    return {};
  }
};

export const isDraftUploadIgnored = (row) => {
  const details = parseDraftUploadAdditionalDetails(row);
  return details.ignored === true || details.ignored === 'true';
};

export const filterDraftUploadsByBusinessUnit = (instances, businessUnitId) => (
  (Array.isArray(instances) ? instances : []).filter((row) => {
    if (!row) return false;
    if (!businessUnitId) return true;
    const details = parseDraftUploadAdditionalDetails(row);
    return (details.businessUnitId || '') === businessUnitId;
  })
);

const resolveInvoiceDocumentTypeId = async (tenantId, token) => {
  const cached = documentTypeIdByTenant.get(tenantId);
  if (cached) return cached;

  const docTypesResponse = await fetch(
    `${BACKEND_BASE}conductor/document-type-tenant-configs/tenant/${tenantId}?category=WF`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  if (!docTypesResponse.ok) {
    throw new Error('Failed to load Invoice document type configuration.');
  }

  const docTypes = await docTypesResponse.json();
  const invoiceConfig = (Array.isArray(docTypes) ? docTypes : []).find(
    (item) => (item.documentTypeName || item.name || '').toLowerCase() === INVOICE_DOC_TYPE_NAME.toLowerCase()
  );
  if (!invoiceConfig?.documentTypeId) {
    throw new Error('Invoice document type is not configured for this tenant.');
  }

  documentTypeIdByTenant.set(tenantId, invoiceConfig.documentTypeId);
  return invoiceConfig.documentTypeId;
};

export const fetchInvoiceDraftFileInstances = async (tenantId, token) => {
  if (!tenantId || !token) return [];

  const documentTypeId = await resolveInvoiceDocumentTypeId(tenantId, token);
  const fileInstancesResponse = await fetch(
    `${BACKEND_BASE}conductor/file-instances/by-document-type/${documentTypeId}?tenantId=${tenantId}`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    }
  );
  if (!fileInstancesResponse.ok) {
    throw new Error(`Failed to fetch draft uploads: ${fileInstancesResponse.status}`);
  }

  const instances = await fileInstancesResponse.json();
  return (Array.isArray(instances) ? instances : [])
    .filter(Boolean)
    .sort((a, b) => {
      const dateA = new Date(a.createdAt || 0);
      const dateB = new Date(b.createdAt || 0);
      return dateB - dateA;
    });
};

export const fetchDraftUploadCount = async (tenantId, token, businessUnitId) => {
  const instances = await fetchInvoiceDraftFileInstances(tenantId, token);
  return filterDraftUploadsByBusinessUnit(instances, businessUnitId)
    .filter((row) => !isDraftUploadIgnored(row))
    .length;
};
